'use client';

import { Tab } from '@headlessui/react';

import TermInfo from './term-info';
import TermsTabList from './terms-tab-list';

const TermScreen = () => {
  return (
    <div className="mt-24 flex w-full flex-col gap-y-10 px-4 lg:px-16">
      <Tab.Group as="div" className="flex w-full flex-col gap-y-4">
        <TermsTabList />
        <Tab.Panels as="div" className="h-full w-full rounded p-4 py-3">
          <TermInfo />
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};

export default TermScreen;
